import React, { useEffect, useRef, useState } from "react";
// import "./Home.scss";


const ServicesSection = ({ registerIntent,url }) => {


  
const SERVICES = [
  {
    id: 1,
    number: "01",
    title: "AI DEVELOPMENT",
    tag: "Automation",
    desc: "AI-powered applications, intelligent assistants, and workflow automation solutions built to improve efficiency, decision-making, and business growth.",
    // Abstract AI neural network — Igor Omilaev (free)
    image: url + "images/new-home/services/ai.jpg",
    accent: "#FF6800",
  },
  {
    id: 2,
    number: "02",
    title: "BRAND SERVICES",
    tag: "Identity",
    desc: "Creative branding, modern UI/UX design, and digital experiences that strengthen your brand presence and connect with your audience.",
    // Design workspace with color swatches — Milad Fakurian (free)
    image: url + "images/new-home/services/brand.jpg",
    accent: "#FFAF00",
  },
  {
    id: 3,
    number: "03",
    title: "CUSTOM DEVELOPMENT",
    tag: "Engineering",
    desc: "Tailored web platforms, enterprise systems, and scalable software solutions developed to match your exact business requirements.",
    // Code on dark screen neon lit — Jakub Żerdzicki (free)
    image: url + "images/new-home/services/custom.jpg",
    accent: "#FF6800",
  },
  {
    id: 4,
    number: "04",
    title: "OFFSHORE DEVELOPMENT",
    tag: "Dedicated",
    desc: "Reliable offshore development teams that integrate seamlessly with your business to deliver high-quality software at scale.",
    // Remote team collaboration global — Chris Montgomery (free)
    image: url + "images/new-home/services/offshore.jpg",
    accent: "#FFAF00",
  },
];

  const [active, setActive]     = useState(0);
  const [prev,   setPrev]       = useState(null);
  const [dir,    setDir]        = useState(1);
  const [animKey, setAnimKey]   = useState(0); // forces text re-animation
  const [loadedImages, setLoadedImages] = useState(() => new Set([0]));
  const activeRef = useRef(0);
  const transitioning = useRef(false);

  // Preload the remaining service images one at a time, in the
  // background, so they don't all compete for connections on mount.
  useEffect(() => {
    let cancelled = false;
    const queue = SERVICES.map((_, i) => i).filter((i) => i !== 0);

    const preloadNext = ([idx, ...rest]) => {
      if (cancelled || idx === undefined) return;
      const img = new Image();
      img.onload = img.onerror = () => {
        if (cancelled) return;
        setLoadedImages((prev) => new Set(prev).add(idx));
        preloadNext(rest);
      };
      img.src = SERVICES[idx].image;
    };

    preloadNext(queue);
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // If the user navigates to a service before its background image has
  // finished preloading, fetch it immediately instead of waiting in queue.
  useEffect(() => {
    if (loadedImages.has(active)) return;
    const img = new Image();
    img.onload = img.onerror = () => {
      setLoadedImages((prev) => new Set(prev).add(active));
    };
    img.src = SERVICES[active].image;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  const goTo = (idx, direction) => {
    if (transitioning.current || idx === activeRef.current) return;
    transitioning.current = true;
    setPrev(activeRef.current);
    setDir(direction);
    activeRef.current = idx;
    setActive(idx);
    setAnimKey(k => k + 1);
    setTimeout(() => {
      setPrev(null);
      transitioning.current = false;
    }, 900);
  };

  useEffect(() => {
    if (!registerIntent) return;
    registerIntent((scrollDir) => {
      const next = activeRef.current + scrollDir;
      if (next >= 0 && next < SERVICES.length) {
        goTo(next, scrollDir);
        return true;
      }
      return false;
    });
  }, [registerIntent]);

  const service = SERVICES[active];

  return (
    <section id="services-section" className="svc">

      {/* ── BACKGROUND IMAGES with clip-path reveal ── */}
      <div className="svc__bg">
        {SERVICES.map((s, i) => (
          <div
            key={s.id}
            className={`svc__bg-img ${
              i === active ? "svc__bg-img--active" :
              i === prev   ? "svc__bg-img--exit"  : ""
            }`}
            style={loadedImages.has(i) ? { backgroundImage: `url(${s.image})` } : undefined}
          />
        ))}
        <div className="svc__bg-noise" />
        <div className="svc__bg-overlay" />
      </div>

      {/* ── LEFT: vertical service tabs ── */}
      <nav className="svc__tabs">
        {/* {SERVICES.map((s, i) => (
          <button
            key={s.id}
            className={`svc__tab ${i === active ? "svc__tab--active" : ""}`}
            onClick={() => goTo(i, i > active ? 1 : -1)}
          >
            <span className="svc__tab-number">{s.number}</span>
            <span className="svc__tab-line" />
            <span className="svc__tab-label">{s.tag}</span>
          </button>
        ))} */}

        {/* <div
          className="svc__tab-indicator"
          style={{ transform: `translateY(${active * 72}px)` }}
        /> */}
      </nav>

      {/* ── CENTER: big title ── */}
      <div className="svc__main">
        <div className="svc__tag-row">
          <span className="svc__tag">{service.tag}</span>
          <span className="svc__tag-num">{service.number} / 0{SERVICES.length}</span>
        </div>

         <div className="svc__title-wrap" key={animKey}>
          {service.title.split(" ").map((word, wi) => (
            <div key={wi} className="svc__title-line">
              {word.split("").map((ch, ci) => (
                <span
                  key={ci}
                  className="svc__title-char"
                  style={{ animationDelay: `${(wi * 10 + ci) * 0.03}s` }}
                >
                  {ch}
                </span>
              ))}
            </div>
          ))}
        </div>

        <p className="svc__desc" key={`desc-${animKey}`}>
          {service.desc}
        </p>

        <button className="svc__cta">
          <span>Explore Service</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {/* ── RIGHT: image card ── */}
      {/* <div className="svc__card-wrap">
        {SERVICES.map((s, i) => (
          <div
            key={s.id}
            className={`svc__card ${
              i === active ? "svc__card--active" :
              i === prev   ? `svc__card--exit svc__card--exit-${dir > 0 ? "up" : "down"}` : ""
            }`}
          >
            <div
              className="svc__card-img"
              style={loadedImages.has(i) ? { backgroundImage: `url(${s.image})` } : undefined}
            />
            <div className="svc__card-info">
              <span>{s.number}</span>
              <span>{s.tag}</span>
            </div>
          </div>
        ))}
      </div> */}

      {/* ── BOTTOM: progress bar ── */}
      <div className="svc__progress">
        <div
          className="svc__progress-fill"
          style={{ width: `${((active + 1) / SERVICES.length) * 100}%` }}
        />
      </div>

    </section>
  );
};

export default ServicesSection;